var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var EventDefinition = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat(['event ', node.name, '(', path.call(_print, 'parameters'), ');']);
  }
};
module.exports = EventDefinition;